import React, { Component } from 'react'
import {Container} from 'react-grid-system'

// STYLES
import styled from 'styled-components'

// HELPERS
import {Section} from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'
import SubTitle from '../../components/subtitle/subtitle.component'
import Button from '../../components/button/button.component'

import Doc1 from '../../assets/docs/ESTUDOQUALITY_online.pdf'
import Doc2 from '../../assets/docs/Relatorio_Final_O_impacto_economico_do_alojamento_local_na_Area_Metropolitana_de_Lisboa_2016-2020.pdf'
import Doc3 from '../../assets/docs/AHRESP-Estudos QUALITY_Norte_Centro_Alentejo.pdf'
import Doc4 from '../../assets/docs/al_algarve_-_estudo_e_caracterizacao_proprietarios_alojamentos_hospedes.pdf'
import Doc5 from '../../assets/docs/impacto_economico_do_alojamento_local_no_algarve.pdf'

export default class Recipients extends Component {
  render () {
    const { t, id } = this.props
    return (
      <Section id={id}>
        <Container>
          <Title color={'#2E84C6'} text={t('Estudos')} />

          <SubTitle color={'#5C5A5A'} text={t('S_frase5')} />
          <ButtonAlign>
            <a href={Doc4} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('S_frase3')} />
            </a>
          </ButtonAlign>

          <SubTitle color={'#5C5A5A'} text={t('S_frase6')} className='mt-5' />
          <ButtonAlign>
            <a href={Doc5} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('S_frase3')} />
            </a>
          </ButtonAlign>

          <SubTitle color={'#5C5A5A'} text={t('S_frase1')} className='mt-5' />
          <ButtonAlign>
            <a href={Doc1} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('S_frase3')} />
            </a>
          </ButtonAlign>

          <SubTitle color={'#5C5A5A'} text={t('S_frase2')} className='mt-5' />
          <ButtonAlign>
            <a href={Doc2} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('S_frase3')} />
            </a>
          </ButtonAlign>

          <SubTitle color={'#5C5A5A'} text={t('S_frase4')} className='mt-5' />
          <ButtonAlign>
            <a href={Doc3} target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('S_frase3')} />
            </a>
          </ButtonAlign>
        </Container>
      </Section>
    )
  }
}

const ButtonAlign = styled.div`
    text-align: center!important;
    margin-right: auto;
    margin-left: auto;
`



// WEBPACK FOOTER //
// ./src/sections/studies/studies.section.js